import React, { useState, memo } from 'react';
import { ShieldCheckIcon, ChevronDownIcon, ChevronUpIcon, LockIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { PurchasePopup } from './PurchasePopup';
import { TestimonialCard } from './TestimonialCard';
const CHECKOUT_URL = 'https://lecturaclara.com/checkouts/cn/hWNAO6sbxhnpJrne5FY1hr1t/es-ar?_r=AQABj74gucXYyf8TYC-QcWD31IvbNahrR3yX27O4UXw_e6o&preview_theme_id=149638185098';
const CHECKOUT_URL_BASE = 'https://lecturaclara.com/checkouts/cn/hWN9y4IeWv8kFo91RRcGVOXR/es-ar?_r=AQABCsB-uksD4ZAUCT4OIXEw_6rByAVWNKLH5KkEucK7YZ4&preview_theme_id=149638185098.js%7D';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/ibLEDHt38UcNC9JzsBreuq/2408fab2-c6ab-4f6e-982f-154737993b72.png';
const BONO1_IMAGE = 'https://cdn.magicpatterns.com/uploads/sf2w9E8JK2U8wzKQduGrBu/7c9d3963-558a-4590-a2eb-1cfc50e345ac.png';
const BONO2_IMAGE = 'https://cdn.magicpatterns.com/uploads/5Q8CsZ8jzhNCEQX2rRLeU5/3f71b0bb-fec6-462c-8eb7-a6b2ace577e6.png';
const BONO3_IMAGE = 'https://cdn.magicpatterns.com/uploads/iG71NbyPYiFQaQJUFuNyLG/e0a4b561-b75c-4f8f-a760-4aca983e1358.png';
const ACELERADOR_IMAGE = 'https://cdn.magicpatterns.com/uploads/nxJq2rpS5UCMT3ttoPcyfQ/ChatGPT_Image_31_mar_2026,_16_44_50.png';
function CTAButton({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`cta-button inline-block bg-green-500 hover:bg-green-600 text-white font-heading font-bold text-lg md:text-2xl px-8 md:px-12 py-4 md:py-5 rounded-lg transition-all duration-200 text-center cursor-pointer no-underline ${className}`} data-id="element-9">
      {children}
    </a>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-10">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 text-left bg-white hover:bg-gray-50 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-solution" aria-expanded={isOpen} data-id="element-11">
        <span className="font-semibold text-gray-900 text-base md:text-lg pr-4" data-id="element-12">
          {question}
        </span>
        {isOpen ? <ChevronUpIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-13" /> : <ChevronDownIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-14" />}
      </button>
      {isOpen && <div className="px-5 pb-5 text-gray-700 leading-relaxed" data-id="element-15">{answer}</div>}
    </div>;
}
export function SalesPage() {
  return <div className="w-full min-h-screen bg-white" data-id="element-16">
      {/* SECTION 1 - STICKY URGENCY BAR */}
      <div className="fixed top-0 left-0 right-0 z-40 bg-red-600 py-2.5 px-4" data-id="element-17">
        <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 flex-wrap text-center" data-id="element-18">
          <span className="text-white font-bold text-sm md:text-base" data-id="element-19">
            ⏳ OFERTA EXPIRA EN:
          </span>
          <CountdownTimer data-id="element-20" />
          <span className="text-white font-semibold text-sm md:text-base" data-id="element-21">
            | 🔥 CUPOS LIMITADOS
          </span>
        </div>
      </div>

      {/* Spacer for sticky bar */}
      <div className="h-12" data-id="element-22" />

      {/* SECTION 2 - HERO */}
      <section className="bg-white py-12 md:py-20 px-4" data-id="element-23">
        <div className="max-w-3xl mx-auto text-center" data-id="element-24">
          <p className="text-gray-600 text-base md:text-lg mb-4" data-id="element-25">
            📚 Para personas que leen… pero no logran retener lo que leen
          </p>

          <h1 className="font-heading font-bold text-4xl md:text-6xl text-solution mb-8 uppercase tracking-tight leading-tight" data-id="element-26">
            PACK Comprensión Lectora Fácil
          </h1>

          <a href="#compra" className="inline-block mb-8" data-id="element-27">
            <img src={PRODUCT_IMAGE} alt="PACK Comprensión Lectora Fácil - Megapack con todos los materiales incluidos" className="max-w-[400px] md:max-w-[500px] w-full mx-auto hover:scale-105 transition-transform duration-300" data-id="element-28" />
          </a>

          <p className="text-lg md:text-xl text-gray-800 font-medium mb-4 leading-relaxed" data-id="element-29">
            El método paso a paso para entender, recordar y retener lo que lees
            sin tener que releer todo varias veces.
          </p>

          <p className="text-base md:text-lg text-gray-600 mb-10 leading-relaxed" data-id="element-30">
            Entrená tu mente para captar ideas, comprender textos y recordar
            información con facilidad.
          </p>

          <a href="#compra" className="cta-button inline-block bg-green-500 hover:bg-green-600 text-white font-heading font-bold text-lg md:text-2xl px-8 md:px-12 py-4 md:py-5 rounded-lg transition-all duration-200 text-center cursor-pointer no-underline w-full md:w-auto" data-id="element-31">
            👉 SÍ, QUIERO ACCEDER AHORA
          </a>

          <p className="text-green-600 font-medium mt-4 text-sm md:text-base" data-id="element-32">
            ✅ Garantía de satisfacción de 7 días
          </p>
        </div>
      </section>

      {/* DIVIDER */}
      <div className="w-full h-1 bg-gradient-to-r from-transparent via-gray-300 to-transparent" data-id="element-33" />

      {/* SECTION 3 - PAIN/PROBLEM (BLACK BG) */}
      <section className="bg-dark-section py-16 md:py-24 px-4" data-id="element-34">
        <div className="max-w-3xl mx-auto text-center" data-id="element-35">
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-white mb-12 uppercase" data-id="element-36">
            Si alguna vez te pasó esto, no estás solo
          </h2>

          <div className="text-gray-300 text-base md:text-lg leading-loose space-y-6 text-left md:text-center" data-id="element-37">
            <p className="text-xl md:text-2xl text-white font-medium" data-id="element-38">
              Leés una página…
            </p>
            <p className="italic text-gray-400" data-id="element-39">
              Y cuando terminás no recordás nada de lo que acabás de leer.
            </p>
            <p data-id="element-40">Entonces volvés al inicio.</p>
            <p data-id="element-41">Leés otra vez.</p>
            <p className="italic text-gray-400" data-id="element-42">
              Pero a mitad del texto tu mente se pierde.
            </p>
            <p className="text-white font-medium" data-id="element-43">
              Y terminás leyendo la misma oración 3 o 4 veces.
            </p>
            <div className="py-4" data-id="element-44">
              <p className="text-gray-400" data-id="element-45">No porque seas lento.</p>
              <p className="text-gray-400" data-id="element-46">No porque no seas inteligente.</p>
            </div>
            <p className="text-yellow-300 text-xl md:text-2xl font-bold font-heading" data-id="element-47">
              Sino porque nadie te enseñó cómo leer para comprender.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4 - THE PROBLEM EXPLAINED */}
      <section className="bg-white py-16 md:py-24 px-4" data-id="element-48">
        <div className="max-w-3xl mx-auto" data-id="element-49">
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-urgency text-center mb-8 uppercase" data-id="element-50">
            El problema que casi nadie te explica
          </h2>

          <div className="text-gray-700 text-base md:text-lg leading-relaxed space-y-4 mb-8" data-id="element-51">
            <p data-id="element-52">La mayoría de las personas aprendieron a leer palabras.</p>
            <p className="font-semibold text-gray-900" data-id="element-53">
              Pero nunca aprendieron a comprender lo que lee.
            </p>
            <p data-id="element-54">Por eso pasa algo muy común:</p>
          </div>

          <ul className="space-y-3 mb-10 text-base md:text-lg" data-id="element-55">
            <li className="flex items-start gap-3" data-id="element-56">
              <span className="text-urgency font-bold text-xl" data-id="element-57">•</span>
              <span className="text-gray-800" data-id="element-58">Leés pero no retenés</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-59">
              <span className="text-urgency font-bold text-xl" data-id="element-60">•</span>
              <span className="text-gray-800" data-id="element-61">
                Tenés que releer varias veces
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-62">
              <span className="text-urgency font-bold text-xl" data-id="element-63">•</span>
              <span className="text-gray-800" data-id="element-64">Te distraés fácilmente</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-65">
              <span className="text-urgency font-bold text-xl" data-id="element-66">•</span>
              <span className="text-gray-800" data-id="element-67">
                Terminás un texto y no sabés qué decía
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-68">
              <span className="text-urgency font-bold text-xl" data-id="element-69">•</span>
              <span className="text-gray-800" data-id="element-70">
                Estudiar te lleva mucho más tiempo
              </span>
            </li>
          </ul>

          <div className="text-gray-700 text-base md:text-lg leading-relaxed space-y-4 mb-10" data-id="element-71">
            <p data-id="element-72">Y eso genera frustración.</p>
            <p data-id="element-73">Porque sentís que tu mente no coopera.</p>
            <p className="font-semibold text-gray-900" data-id="element-74">
              Pero la verdad es otra:
            </p>
          </div>

          <div className="bg-yellow-50 border-2 border-yellow-400 rounded-xl p-6 md:p-8 text-center" data-id="element-75">
            <p className="font-heading font-bold text-xl md:text-3xl text-solution" data-id="element-76">
              👉 No es falta de inteligencia.
              <br data-id="element-77" />
              Es falta de método.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 5 - THE SOLUTION */}
      <section className="bg-white py-16 md:py-24 px-4 border-t-4 border-solution" data-id="element-78">
        <div className="max-w-3xl mx-auto text-center" data-id="element-79">
          <span className="inline-block bg-green-600 text-white font-heading font-bold text-sm md:text-base px-5 py-2 rounded-full mb-6 uppercase tracking-wide" data-id="element-80">
            ✅ LA SOLUCIÓN
          </span>

          <h2 className="font-heading font-bold text-3xl md:text-5xl text-solution mb-6 uppercase" data-id="element-81">
            PACK Comprensión Lectora Fácil
          </h2>

          <p className="text-gray-700 text-base md:text-lg mb-4 leading-relaxed" data-id="element-82">
            Un sistema práctico diseñado para entrenar tu mente a comprender y
            retener lo que lees.
          </p>

          <p className="text-gray-600 text-base md:text-lg mb-8" data-id="element-83">
            No es teoría complicada.
          </p>

          <p className="text-gray-800 text-lg md:text-xl font-medium mb-8" data-id="element-84">
            Es un método claro que te enseña:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-lg mx-auto mb-12 text-left" data-id="element-85">
            <div className="flex items-center gap-3 text-base md:text-lg" data-id="element-86">
              <span className="text-green-600 font-bold text-xl" data-id="element-87">✔</span>
              <span className="text-gray-800" data-id="element-88">cómo procesar información</span>
            </div>
            <div className="flex items-center gap-3 text-base md:text-lg" data-id="element-89">
              <span className="text-green-600 font-bold text-xl" data-id="element-90">✔</span>
              <span className="text-gray-800" data-id="element-91">
                cómo identificar ideas importantes
              </span>
            </div>
            <div className="flex items-center gap-3 text-base md:text-lg" data-id="element-92">
              <span className="text-green-600 font-bold text-xl" data-id="element-93">✔</span>
              <span className="text-gray-800" data-id="element-94">cómo recordar lo que leés</span>
            </div>
            <div className="flex items-center gap-3 text-base md:text-lg" data-id="element-95">
              <span className="text-green-600 font-bold text-xl" data-id="element-96">✔</span>
              <span className="text-gray-800" data-id="element-97">
                cómo evitar releer todo el tiempo
              </span>
            </div>
          </div>

          <p className="text-gray-800 text-lg md:text-xl font-medium mb-8" data-id="element-98">
            El proceso es simple:
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-10" data-id="element-99">
            <div className="bg-blue-50 rounded-xl p-6 text-center w-48" data-id="element-100">
              <span className="text-4xl mb-2 block" data-id="element-101">📖</span>
              <p className="font-heading font-bold text-solution text-lg" data-id="element-102">
                Leés el texto
              </p>
            </div>
            <span className="text-3xl text-gray-400 hidden md:block" data-id="element-103">→</span>
            <span className="text-3xl text-gray-400 md:hidden" data-id="element-104">↓</span>
            <div className="bg-blue-50 rounded-xl p-6 text-center w-48" data-id="element-105">
              <span className="text-4xl mb-2 block" data-id="element-106">🔎</span>
              <p className="font-heading font-bold text-solution text-lg" data-id="element-107">
                Identificás lo importante
              </p>
            </div>
            <span className="text-3xl text-gray-400 hidden md:block" data-id="element-108">→</span>
            <span className="text-3xl text-gray-400 md:hidden" data-id="element-109">↓</span>
            <div className="bg-blue-50 rounded-xl p-6 text-center w-48" data-id="element-110">
              <span className="text-4xl mb-2 block" data-id="element-111">🧠</span>
              <p className="font-heading font-bold text-solution text-lg" data-id="element-112">
                Tu mente lo retiene
              </p>
            </div>
          </div>

          <p className="text-gray-700 text-lg md:text-xl leading-relaxed" data-id="element-113">
            Sin frustración.
            <br data-id="element-114" />
            Sin confusión.
            <br data-id="element-115" />
            Sin perder tiempo.
          </p>
        </div>
      </section>

      {/* SECTION 6 - WHAT'S INCLUDED */}
      <section className="bg-gray-50 py-16 md:py-24 px-4" data-id="element-116">
        <div className="max-w-3xl mx-auto" data-id="element-117">
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-solution text-center mb-10 uppercase" data-id="element-118">
            📘 ¿Qué incluye exactamente el PACK?
          </h2>

          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-10 mb-10" data-id="element-119">
            <h3 className="font-heading font-bold text-2xl md:text-3xl text-solution mb-6" data-id="element-120">
              📗 Ebook principal: Comprensión Lectora Fácil
            </h3>

            <p className="text-gray-700 text-base md:text-lg mb-6 leading-relaxed" data-id="element-121">
              Un sistema completo para mejorar la comprensión y retención de
              lectura.
            </p>

            <p className="text-gray-800 text-lg font-semibold mb-4" data-id="element-122">
              Aprenderás a:
            </p>

            <ul className="space-y-3 text-base md:text-lg" data-id="element-123">
              <li className="flex items-start gap-3" data-id="element-124">
                <span className="text-green-600 font-bold text-xl flex-shrink-0" data-id="element-125">
                  •
                </span>
                <span className="text-gray-800" data-id="element-126">
                  Comprender textos más rápido
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-127">
                <span className="text-green-600 font-bold text-xl flex-shrink-0" data-id="element-128">
                  •
                </span>
                <span className="text-gray-800" data-id="element-129">
                  Retener información importante
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-130">
                <span className="text-green-600 font-bold text-xl flex-shrink-0" data-id="element-131">
                  •
                </span>
                <span className="text-gray-800" data-id="element-132">
                  Evitar releer constantemente
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-133">
                <span className="text-green-600 font-bold text-xl flex-shrink-0" data-id="element-134">
                  •
                </span>
                <span className="text-gray-800" data-id="element-135">
                  Concentrarte mientras lees
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-136">
                <span className="text-green-600 font-bold text-xl flex-shrink-0" data-id="element-137">
                  •
                </span>
                <span className="text-gray-800" data-id="element-138">
                  Procesar información con claridad
                </span>
              </li>
            </ul>

            <p className="text-gray-600 text-base mt-6 italic" data-id="element-139">
              Todo explicado paso a paso y sin tecnicismos.
            </p>
          </div>

          {/* EXTRA PERSUASIVE CTA */}
          <div className="text-center" data-id="element-140">
            <CTAButton className="w-full md:w-auto" data-id="element-141">
              🚀 QUIERO MEJORAR MI COMPRENSIÓN LECTORA HOY
            </CTAButton>
          </div>
        </div>
      </section>

      {/* SECTION 7 - BONUSES */}
      <section className="bg-white py-16 md:py-24 px-4" data-id="element-142">
        <div className="max-w-4xl mx-auto" data-id="element-143">
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-urgency text-center mb-4 uppercase" data-id="element-144">
            🎁 BONOS ESPECIALES – GRATIS HOY
          </h2>
          <p className="text-center text-gray-600 text-base md:text-lg mb-12" data-id="element-145">
            Estos bonos son{' '}
            <span className="font-bold text-urgency" data-id="element-146">GRATIS</span> por el día de
            hoy con tu compra del PACK
          </p>

          {/* Bono 1 */}
          <div className="bg-orange-50 border-2 border-orange-300 rounded-2xl p-6 md:p-10 mb-8 flex flex-col md:flex-row items-center gap-8" data-id="element-147">
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="flex-shrink-0" data-id="element-148">
              <img src={BONO1_IMAGE} alt="Bono #1 - Ejercicios de Entrenamiento Mental" className="w-[280px] md:w-[320px] aspect-square object-cover rounded-xl hover:scale-105 transition-transform duration-300" data-id="element-149" />
            </a>
            <div className="text-center md:text-left" data-id="element-150">
              <span className="inline-block bg-orange-500 text-white font-heading font-bold text-sm px-4 py-1 rounded-full mb-3" data-id="element-151">
                🎁 Bono #1
              </span>
              <h3 className="font-heading font-bold text-2xl md:text-3xl text-gray-900 mb-3" data-id="element-152">
                Ejercicios de Entrenamiento Mental
              </h3>
              <p className="text-gray-700 text-base md:text-lg mb-4 leading-relaxed" data-id="element-153">
                Actividades para mejorar concentración y memoria durante la
                lectura.
              </p>
              <p className="text-gray-500 line-through text-base mb-1" data-id="element-154">
                Valor: $9.990
              </p>
              <p className="text-green-600 font-bold text-xl font-heading" data-id="element-155">
                HOY: GRATIS
              </p>
            </div>
          </div>

          {/* Bono 2 */}
          <div className="bg-green-50 border-2 border-green-300 rounded-2xl p-6 md:p-10 mb-8 flex flex-col md:flex-row items-center gap-8" data-id="element-156">
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="flex-shrink-0" data-id="element-157">
              <img src={BONO2_IMAGE} alt="Bono #2 - Guía para Recordar lo que Lees" className="w-[280px] md:w-[320px] aspect-square object-cover rounded-xl hover:scale-105 transition-transform duration-300" data-id="element-158" />
            </a>
            <div className="text-center md:text-left" data-id="element-159">
              <span className="inline-block bg-green-600 text-white font-heading font-bold text-sm px-4 py-1 rounded-full mb-3" data-id="element-160">
                🎁 Bono #2
              </span>
              <h3 className="font-heading font-bold text-2xl md:text-3xl text-gray-900 mb-3" data-id="element-161">
                Guía para Recordar lo que Lees
              </h3>
              <p className="text-gray-700 text-base md:text-lg mb-4 leading-relaxed" data-id="element-162">
                Técnicas simples para memorizar y retener información.
              </p>
              <p className="text-gray-500 line-through text-base mb-1" data-id="element-163">
                Valor: $9.990
              </p>
              <p className="text-green-600 font-bold text-xl font-heading" data-id="element-164">
                HOY: GRATIS
              </p>
            </div>
          </div>

          {/* Bono 3 */}
          <div className="bg-blue-50 border-2 border-blue-300 rounded-2xl p-6 md:p-10 mb-8 flex flex-col md:flex-row items-center gap-8" data-id="element-165">
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="flex-shrink-0" data-id="element-166">
              <img src={BONO3_IMAGE} alt="Bono #3 - Sistema de Lectura Inteligente" className="w-[280px] md:w-[320px] aspect-square object-cover rounded-xl hover:scale-105 transition-transform duration-300" data-id="element-167" />
            </a>
            <div className="text-center md:text-left" data-id="element-168">
              <span className="inline-block bg-blue-600 text-white font-heading font-bold text-sm px-4 py-1 rounded-full mb-3" data-id="element-169">
                🎁 Bono #3
              </span>
              <h3 className="font-heading font-bold text-2xl md:text-3xl text-gray-900 mb-3" data-id="element-170">
                Sistema de Lectura Inteligente
              </h3>
              <p className="text-gray-700 text-base md:text-lg mb-4 leading-relaxed" data-id="element-171">
                Un método rápido para entender textos largos sin perderte.
              </p>
              <p className="text-gray-500 line-through text-base mb-1" data-id="element-172">
                Valor: $9.990
              </p>
              <p className="text-green-600 font-bold text-xl font-heading" data-id="element-173">
                HOY: GRATIS
              </p>
            </div>
          </div>

          {/* EXCLUSIVO COMBO PRO - Acelerador de Aprendizaje */}
          <div className="relative mt-12" data-id="element-174">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 z-10" data-id="element-175">
              <span className="inline-block bg-gradient-to-r from-yellow-500 to-amber-600 text-black font-heading font-bold text-sm md:text-base px-6 py-2 rounded-full uppercase tracking-wide shadow-lg shadow-amber-500/30" data-id="element-176">
                🏆 EXCLUSIVO COMBO PRO
              </span>
            </div>
            <div className="border-2 border-amber-500/70 rounded-2xl p-6 md:p-10 flex flex-col md:flex-row items-center gap-8" data-id="element-177">
              <a href="#compra" className="flex-shrink-0" data-id="element-178">
                <img src={ACELERADOR_IMAGE} alt="Acelerador de Aprendizaje - Sistema de ejecución exclusivo del Combo Pro" className="w-[280px] md:w-[320px] rounded-xl hover:scale-105 transition-transform duration-300" data-id="element-179" />
              </a>
              <div className="text-center md:text-left" data-id="element-180">
                <h3 className="font-heading font-bold text-2xl md:text-3xl text-amber-400 mb-2" data-id="element-181">
                  🔥 ACELERADOR DE APRENDIZAJE
                </h3>
                <p className="text-gray-300 text-base md:text-lg mb-4 leading-relaxed" data-id="element-182">
                  El sistema que te lleva de{' '}
                  <span className="text-white font-semibold" data-id="element-183">aprender</span> a{' '}
                  <span className="text-white font-semibold" data-id="element-184">ejecutar</span>:
                  aplicá lo que leés con un método paso a paso y convertilo en
                  resultados reales.
                </p>
                <div className="flex items-center gap-3 flex-wrap" data-id="element-185">
                  <p className="text-gray-500 line-through text-base" data-id="element-186">
                    Valor: $16.990
                  </p>
                  <p className="text-amber-400 font-bold text-xl font-heading" data-id="element-187">
                    INCLUIDO EN EL COMBO PRO
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 8 - BEFORE vs AFTER (BLACK BG) */}
      <section className="bg-dark-section py-16 md:py-24 px-4" data-id="element-188">
        <div className="max-w-4xl mx-auto" data-id="element-189">
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-white text-center mb-12 uppercase" data-id="element-190">
            🔄 Antes vs Después
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-191">
            {/* Before */}
            <div className="bg-red-950/40 border border-red-800/50 rounded-2xl p-8" data-id="element-192">
              <h3 className="font-heading font-bold text-2xl text-red-400 mb-6 text-center" data-id="element-193">
                ❌ Antes del PACK
              </h3>
              <ul className="space-y-4" data-id="element-194">
                <li className="flex items-start gap-3" data-id="element-195">
                  <span className="text-red-400 flex-shrink-0" data-id="element-196">•</span>
                  <span className="text-gray-300" data-id="element-197">
                    Leer varias veces lo mismo
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-198">
                  <span className="text-red-400 flex-shrink-0" data-id="element-199">•</span>
                  <span className="text-gray-300" data-id="element-200">
                    Olvidar lo que acabás de leer
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-201">
                  <span className="text-red-400 flex-shrink-0" data-id="element-202">•</span>
                  <span className="text-gray-300" data-id="element-203">
                    Dificultad para concentrarte
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-204">
                  <span className="text-red-400 flex-shrink-0" data-id="element-205">•</span>
                  <span className="text-gray-300" data-id="element-206">
                    Estudiar se vuelve pesado
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-207">
                  <span className="text-red-400 flex-shrink-0" data-id="element-208">•</span>
                  <span className="text-gray-300" data-id="element-209">
                    Frustración al leer textos largos
                  </span>
                </li>
              </ul>
            </div>

            {/* After */}
            <div className="bg-green-950/40 border border-green-800/50 rounded-2xl p-8" data-id="element-210">
              <h3 className="font-heading font-bold text-2xl text-green-400 mb-6 text-center" data-id="element-211">
                ✅ Después del PACK
              </h3>
              <ul className="space-y-4" data-id="element-212">
                <li className="flex items-start gap-3" data-id="element-213">
                  <span className="text-green-400 flex-shrink-0" data-id="element-214">•</span>
                  <span className="text-gray-300" data-id="element-215">
                    Comprender lo que lees fácilmente
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-216">
                  <span className="text-green-400 flex-shrink-0" data-id="element-217">•</span>
                  <span className="text-gray-300" data-id="element-218">
                    Recordar la información importante
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-219">
                  <span className="text-green-400 flex-shrink-0" data-id="element-220">•</span>
                  <span className="text-gray-300" data-id="element-221">
                    Leer con mayor concentración
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-222">
                  <span className="text-green-400 flex-shrink-0" data-id="element-223">•</span>
                  <span className="text-gray-300" data-id="element-224">Estudiar más rápido</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-225">
                  <span className="text-green-400 flex-shrink-0" data-id="element-226">•</span>
                  <span className="text-gray-300" data-id="element-227">
                    Mayor seguridad al aprender
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="text-center mt-12" data-id="element-228">
            <CTAButton data-id="element-229">👉 SÍ, QUIERO ACCEDER AHORA</CTAButton>
          </div>
        </div>
      </section>

      {/* SECTION 9 - TESTIMONIALS */}
      <section className="bg-gray-50 py-16 md:py-24 px-4" data-id="element-230">
        <div className="max-w-4xl mx-auto" data-id="element-231">
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-solution text-center mb-12 uppercase" data-id="element-232">
            Lo que dicen quienes ya lo probaron
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-233">
            <TestimonialCard name="Valentina R." age="23 años" role="Estudiante universitaria" quote="Siempre me costaba estudiar porque leía las cosas mil veces y no me quedaba nada. Con este método empecé a entender los textos de la facultad a la primera. Me cambió la forma de estudiar por completo." rating={5} data-id="element-234" />
            <TestimonialCard name="Martín G." age="35 años" role="Profesional" quote="En el trabajo tengo que leer informes largos todos los días. Antes me tomaba horas y terminaba sin retener lo importante. Ahora proceso la información mucho más rápido y con más claridad." rating={5} data-id="element-235" />
            <TestimonialCard name="Camila S." age="28 años" role="Opositora" quote="Estoy preparando un examen y el volumen de lectura es enorme. Este pack me enseñó a identificar lo clave de cada texto sin perder tiempo. Rindo mucho mejor ahora." rating={5} data-id="element-236" />
            <TestimonialCard name="Diego L." age="41 años" role="Padre de familia" quote="Lo compré para ayudar a mis hijos con el estudio, pero terminé usándolo yo también. Es increíble cómo algo tan simple puede mejorar tanto la forma en que uno lee y retiene." rating={5} data-id="element-237" />
          </div>
          <div className="max-w-md mx-auto" data-id="element-238">
            <TestimonialCard name="Sofía M." age="19 años" role="Estudiante" quote="Los libros de texto me parecían imposibles. Leía y releía sin entender. Desde que aplico las técnicas del pack, puedo leer un capítulo entero y recordar los puntos importantes. Lo recomiendo mucho." rating={5} data-id="element-239" />
          </div>
        </div>
      </section>

      {/* SECTION 10 - PRICING TIERS */}
      <section id="compra" className="bg-gradient-to-b from-gray-50 to-white py-16 md:py-24 px-4" data-id="element-240">
        <div className="max-w-5xl mx-auto" data-id="element-241">
          <div className="text-center mb-4" data-id="element-242">
            <span className="inline-block bg-red-600 text-white font-heading font-bold text-sm md:text-base px-5 py-2 rounded-full mb-4 uppercase tracking-wide animate-pulse" data-id="element-243">
              🔥 OFERTA POR TIEMPO LIMITADO
            </span>
          </div>
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-solution text-center mb-4 uppercase" data-id="element-244">
            🎯 Elegí tu PACK
          </h2>
          <p className="text-center text-gray-600 text-base md:text-lg mb-12 max-w-2xl mx-auto" data-id="element-245">
            Seleccioná la opción que mejor se adapte a tus necesidades. El Combo
            Pro incluye nuestro acelerador exclusivo para resultados más
            rápidos.
          </p>

          <div className="flex flex-col md:flex-row gap-8 items-center md:items-stretch justify-center" data-id="element-246">
            {/* COMBO PRO - Premium (FIRST) */}
            <div className="w-full md:w-1/2 max-w-md bg-dark-section rounded-3xl border-2 border-green-500 p-8 relative flex flex-col transform md:scale-105 shadow-2xl z-10" data-id="element-247">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-green-600 text-white font-bold px-6 py-1.5 rounded-full text-sm flex items-center gap-2 whitespace-nowrap shadow-lg" data-id="element-248">
                ⭐ MÁS ELEGIDO
              </div>

              <div className="flex justify-between items-start mb-6 mt-2" data-id="element-249">
                <div data-id="element-250">
                  <div className="flex items-center gap-2 mb-1" data-id="element-251">
                    <span className="text-2xl" data-id="element-252">🏆</span>
                    <h3 className="font-heading font-bold text-2xl text-white" data-id="element-253">
                      COMBO PRO
                    </h3>
                  </div>
                  <div className="inline-block border border-green-500/50 bg-green-500/10 rounded-full px-3 py-1 text-xs text-green-400 mt-2 font-medium" data-id="element-254">
                    AHORRÁS $26.510
                  </div>
                </div>
                <div className="text-right" data-id="element-255">
                  <p className="text-gray-400 line-through text-sm mb-1" data-id="element-256">
                    $56.500
                  </p>
                  <p className="font-heading font-bold text-4xl text-green-500" data-id="element-257">
                    $29.990
                  </p>
                </div>
              </div>

              <div className="flex-1" data-id="element-258">
                <ul className="space-y-4 text-gray-300 mb-8" data-id="element-259">
                  <li className="flex items-start gap-3" data-id="element-260">
                    <span className="text-green-500 font-bold text-lg" data-id="element-261">✓</span>
                    <span data-id="element-262">Ebook Comprensión Lectora Fácil</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-263">
                    <span className="text-green-500 font-bold text-lg" data-id="element-264">✓</span>
                    <span data-id="element-265">Bono #1: Ejercicios de entrenamiento mental</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-266">
                    <span className="text-green-500 font-bold text-lg" data-id="element-267">✓</span>
                    <span data-id="element-268">Bono #2: Guía para recordar lo que lees</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-269">
                    <span className="text-green-500 font-bold text-lg" data-id="element-270">✓</span>
                    <span data-id="element-271">Bono #3: Sistema de lectura inteligente</span>
                  </li>
                  <li className="flex items-start gap-3 bg-green-900/40 p-4 rounded-xl border border-green-500/30 mt-6" data-id="element-272">
                    <span className="text-xl" data-id="element-273">🎁</span>
                    <span className="text-green-50 font-medium" data-id="element-274">
                      ACELERADOR DE APRENDIZAJE🔥(Sistema de ejecución para
                      aplicar lo que aprendes)
                    </span>
                  </li>
                </ul>
              </div>

              <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="w-full block text-center bg-green-500 hover:bg-green-600 text-white font-heading font-bold text-lg py-4 rounded-xl transition-colors shadow-lg shadow-green-500/30" data-id="element-275">
                QUIERO EL COMBO PRO
              </a>
            </div>

            {/* PACK BASE - Basic (SECOND) */}
            <div className="w-full md:w-1/2 max-w-md bg-dark-section rounded-3xl border border-gray-600 p-8 flex flex-col mt-4 md:mt-0" data-id="element-276">
              <div className="flex justify-between items-start mb-6" data-id="element-277">
                <div data-id="element-278">
                  <div className="flex items-center gap-2 mb-1" data-id="element-279">
                    <span className="text-2xl" data-id="element-280">💚</span>
                    <h3 className="font-heading font-bold text-2xl text-white" data-id="element-281">
                      PACK BASE
                    </h3>
                  </div>
                </div>
                <div className="text-right" data-id="element-282">
                  <p className="text-gray-500 line-through text-sm mb-1" data-id="element-283">
                    $39.990
                  </p>
                  <p className="font-heading font-bold text-4xl text-white" data-id="element-284">
                    $19.990
                  </p>
                </div>
              </div>

              <div className="flex-1" data-id="element-285">
                <ul className="space-y-4 text-gray-400 mb-8" data-id="element-286">
                  <li className="flex items-start gap-3" data-id="element-287">
                    <span className="text-gray-500 font-bold text-lg" data-id="element-288">✓</span>
                    <span data-id="element-289">Ebook Comprensión Lectora Fácil</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-290">
                    <span className="text-gray-500 font-bold text-lg" data-id="element-291">✓</span>
                    <span data-id="element-292">Bono #1: Ejercicios de entrenamiento mental</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-293">
                    <span className="text-gray-500 font-bold text-lg" data-id="element-294">✓</span>
                    <span data-id="element-295">Bono #2: Guía para recordar lo que lees</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-296">
                    <span className="text-gray-500 font-bold text-lg" data-id="element-297">✓</span>
                    <span data-id="element-298">Bono #3: Sistema de lectura inteligente</span>
                  </li>
                </ul>
              </div>

              <a href={CHECKOUT_URL_BASE} target="_blank" rel="noopener noreferrer" className="w-full block text-center bg-transparent border-2 border-gray-500 hover:border-gray-400 text-white font-heading font-bold text-lg py-4 rounded-xl transition-colors" data-id="element-299">
                ELEGIR PACK BASE
              </a>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-300">
            <p className="text-green-600 font-bold text-lg" data-id="element-301">
              ✅ Garantía de satisfacción de 7 días | 🔒 Compra 100% segura
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 11 - GUARANTEE */}
      <section className="bg-gray-50 py-16 md:py-20 px-4" data-id="element-302">
        <div className="max-w-2xl mx-auto text-center" data-id="element-303">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6" data-id="element-304">
            <ShieldCheckIcon className="w-10 h-10 text-green-600" data-id="element-305" />
          </div>

          <h2 className="font-heading font-bold text-3xl md:text-4xl text-gray-900 mb-6" data-id="element-306">
            🔒 Garantía sin riesgo
          </h2>

          <div className="text-gray-700 text-base md:text-lg leading-relaxed space-y-4" data-id="element-307">
            <p data-id="element-308">Probalo durante 7 días completos.</p>
            <p data-id="element-309">
              Si sentís que no mejora tu capacidad para comprender o recordar lo
              que lees, te devolvemos el <strong data-id="element-310">100% del dinero</strong>.
            </p>
            <p className="font-bold text-gray-900 text-lg" data-id="element-311">Sin preguntas.</p>
          </div>

          <div className="flex items-center justify-center gap-2 mt-6 text-gray-500 text-sm" data-id="element-312">
            <LockIcon className="w-4 h-4" data-id="element-313" />
            <span data-id="element-314">Compra segura y protegida</span>
          </div>
        </div>
      </section>

      {/* SECTION 12 - FAQ */}
      <section className="bg-white py-16 md:py-24 px-4" data-id="element-315">
        <div className="max-w-3xl mx-auto" data-id="element-316">
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-solution text-center mb-10 uppercase" data-id="element-317">
            ❓ Preguntas frecuentes
          </h2>

          <div className="space-y-3" data-id="element-318">
            <FAQItem question="¿Este material sirve para adultos?" answer="Sí. Está pensado para personas que quieren mejorar su comprensión lectora, sin importar la edad." data-id="element-319" />
            <FAQItem question="¿También sirve para estudiantes?" answer="Sí. De hecho, muchos estudiantes lo usan para estudiar mejor y más rápido." data-id="element-320" />
            <FAQItem question="¿Es difícil de aplicar?" answer="No. El método está explicado paso a paso." data-id="element-321" />
            <FAQItem question="¿Es material digital?" answer="Sí. Tendrás acceso inmediato para descargarlo." data-id="element-322" />
          </div>
        </div>
      </section>

      {/* SECTION 13 - FINAL CTA (BLACK BG) */}
      <section className="bg-dark-section py-16 md:py-24 px-4" data-id="element-323">
        <div className="max-w-3xl mx-auto text-center" data-id="element-324">
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-white mb-6 uppercase leading-tight" data-id="element-325">
            Comprender lo que lees puede cambiar cómo aprendes
          </h2>

          <p className="text-gray-300 text-base md:text-lg mb-4 leading-relaxed" data-id="element-326">
            Leer no debería sentirse como una lucha.
          </p>

          <p className="text-gray-300 text-base md:text-lg mb-10 leading-relaxed" data-id="element-327">
            Con el método correcto, tu mente puede entender, procesar y recordar
            mucho más fácil.
          </p>

          <CTAButton className="w-full md:w-auto" data-id="element-328">
            👉 Accedé ahora al PACK Comprensión Lectora Fácil
          </CTAButton>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black py-6 px-4 text-center" data-id="element-329">
        <p className="text-gray-500 text-sm" data-id="element-330">
          © {new Date().getFullYear()} Lectura Clara. Todos los derechos
          reservados.
        </p>
      </footer>

      {/* Purchase Popup */}
      <PurchasePopup data-id="element-331" />
    </div>;
}